import { Navigate, useLocation } from 'react-router-dom';
import { getMenuChangeReturnPath } from '../services/menuChange/menuChangeLinks';
import { useAuth } from '../services/authentication/authContext';
import { useSubscription } from '../hooks/useSubscription';
import { useAppUserDefaultStore } from '../stores/appUserDefaultStore';

export function SubscriptionRoute({ children }: { children: JSX.Element }) {
  const location = useLocation();
  const { user, loading: authLoading } = useAuth();
  const { isActive, loading: subscriptionLoading } = useSubscription();
  
  const hasSentToPayment = useAppUserDefaultStore(state => state.hasSentToPayment);
  const setHasSentToPayment = useAppUserDefaultStore(state => state.setHasSentToPayment);
  if (authLoading || subscriptionLoading) {
    return <div>Loading…</div>;
  }

  if (!user) {
    return <Navigate to="/login" state={{ menuChangeReturnTo: getMenuChangeReturnPath(location.pathname + location.search + location.hash) }} replace />;
  }

  if (!isActive && !hasSentToPayment) {
    return <Navigate to="/payment" replace />;
  } else if (!isActive) {
    setHasSentToPayment(true);
  }

  return <div className="p-3 min-[650px]:p-6">{children}</div>;
}
